import { ApiConfig } from '../../../Config.js';
import axios from 'axios';


var VerifyOtpPVCtrl = function (fn, er, state, ids, user) {

	var config = {
		headers: {
			//'Authorization': 'Bearer ' + token,
			'Content-Type': 'application/json',
			'MT_SESSION_ID': ids
		},

	};
	var data = {
		otp: state.otpCode,
		user: user
	};

	axios
		.post(ApiConfig.url.VERIFY_OTP_POS, data, config)
		.then(function (result) {
			fn(result.data, result.status)
		})
		.catch(function (error) {
			er(error !== undefined && error.response !== undefined && error.response.status !== undefined ? error.response.status : 500, error.response.data.details[0])
		});
}

export { VerifyOtpPVCtrl };